var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotionCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BOUTON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 281,
    height: 62,
    viewBox: "0 0 281 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Close",
    "data-name": "Rectangle Close",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 62,
    rx: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 279,
    height: 60,
    rx: 30,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_Close",
    "data-name": "Path Close",
    d: "M-17.256-16.344l6.48,13.392a3.131,3.131,0,0,1,.408,1.224q0,.864-1.392,1.56A3.148,3.148,0,0,1-13.044.24a1.282,1.282,0,0,1-.768-.216,1.434,1.434,0,0,1-.432-.456q-.132-.24-.372-.72l-1.248-2.592h-6.648L-23.76-1.152q-.24.48-.372.7a1.709,1.709,0,0,1-.432.444,1.234,1.234,0,0,1-.768.228,3.148,3.148,0,0,1-1.284-.408q-1.392-.672-1.392-1.536A3.131,3.131,0,0,1-27.6-2.952l6.48-13.416a2.1,2.1,0,0,1,.8-.888,2.124,2.124,0,0,1,1.14-.336A2.032,2.032,0,0,1-17.256-16.344Zm-1.944,5.76L-20.784-7.3h3.192Zm10.152-4.9a6.972,6.972,0,0,1,.036-.828,1.923,1.923,0,0,1,.228-.636q.336-.648,1.872-.648,1.68,0,1.992.888a4.773,4.773,0,0,1,.12,1.248V-2.112a6.928,6.928,0,0,1-.036.84,1.935,1.935,0,0,1-.228.624Q-5.4,0-6.936,0-8.616,0-8.9-.912a3.774,3.774,0,0,1-.144-1.224Zm8.3-2.136,4.44.024a8.616,8.616,0,0,1,6.12,2.508,8.174,8.174,0,0,1,2.64,6.168A8.62,8.62,0,0,1,9.876-2.64,8.456,8.456,0,0,1,3.624-.024H-.768q-1.464,0-1.824-.6A3.189,3.189,0,0,1-2.88-2.16V-15.5a6.928,6.928,0,0,1,.036-.84,1.935,1.935,0,0,1,.228-.624Q-2.28-17.616-.744-17.616ZM3.7-4.272a4.489,4.489,0,0,0,3.12-1.284A4.206,4.206,0,0,0,8.208-8.784a4.335,4.335,0,0,0-1.356-3.252,4.433,4.433,0,0,0-3.18-1.308h-2.3v9.072Zm14.568.024h7.392a6.972,6.972,0,0,1,.828.036,1.923,1.923,0,0,1,.636.228q.648.336.648,1.872,0,1.68-.888,1.968A4.013,4.013,0,0,1,25.632,0h-9.5q-1.68,0-1.968-.912a3.774,3.774,0,0,1-.144-1.224V-15.48a2.325,2.325,0,0,1,.456-1.668,2.508,2.508,0,0,1,1.728-.444h9.456a6.972,6.972,0,0,1,.828.036,1.923,1.923,0,0,1,.636.228q.648.336.648,1.872,0,1.68-.888,1.968a4.013,4.013,0,0,1-1.248.144H18.264v2.424h4.752a6.972,6.972,0,0,1,.828.036,1.923,1.923,0,0,1,.636.228q.648.336.648,1.872,0,1.68-.912,1.968a4.013,4.013,0,0,1-1.248.144h-4.7Z",
    transform: "translate(141 40)",
    fill: "#e1503c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M32.348,28.312,44.511,16.149a2.85,2.85,0,1,0-4.031-4.031L28.317,24.281,16.154,12.118a2.85,2.85,0,1,0-4.031,4.031L24.287,28.312,12.123,40.475a2.85,2.85,0,0,0,4.031,4.031L28.317,32.343,40.481,44.506a2.85,2.85,0,0,0,4.031-4.031Z",
    transform: "translate(18.674 2.688)",
    fill: "#e1503c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotionCloseBtn);
export default __webpack_public_path__ + "static/media/notion-close-btn.9553bf99.svg";
export { ForwardRef as ReactComponent };